import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';
import setMailboxAutoReplyConfigurationOperation from 'owa-service/lib/operation/setMailboxAutoReplyConfigurationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Makes the call to the server to set automatic reply configuration
 * @param {MailboxAutoReplyConfigurationOptions} options automatic replies configuration to set on server
 * @returns promise of MailboxAutoReplyConfigurationOptions type
 */
export default function saveMailboxAutomaticRepliesConfiguration(
    options: MailboxAutoReplyConfigurationOptions
): Promise<MailboxAutoReplyConfigurationOptions> {
    return setMailboxAutoReplyConfigurationOperation({
        Header: getJsonRequestHeader(),
        Options: options,
    });
}
